module.exports = __webpack_public_path__ + "static/img/technology.c8d0bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/technology.png
// module id = IWUi
// module chunks = 1